module.exports = __webpack_public_path__ + "static/media/MINISERIF-REGULAR.c8746e29.TTF";